import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  background: ${(p) => p.theme.palette.common.white};
`;
